import { defineMessages } from "react-intl";
import { KycStatus } from "../../contract/pam.js";
const localizedKycStatus = defineMessages({
  [KycStatus.Successful]: {
    id: "kycStatusPass",
    defaultMessage: "Pass"
  },
  [KycStatus.Pending]: {
    id: "kycStatusPending",
    defaultMessage: "Pending"
  },
  [KycStatus.Failed]: {
    id: "kycStatusFailed",
    defaultMessage: "Failed"
  },
  [KycStatus.None]: {
    id: "kycStatusPending",
    defaultMessage: "Pending"
  }
});
export {
  localizedKycStatus
};
//# sourceMappingURL=kycStatus.js.map
